// Serwis wideo-instrukcji obsługi (przycisk „?” w nagłówku).
import { fetchWrapper } from "@/helpers/fetch-wrapper";

class ManualService {
  /**
   * Pobiera działy instrukcji dostępne dla zalogowanego użytkownika (backend filtruje je
   * po uprawnieniach). Każdy dział ma bilet do strumienia wideo, ważny przez kilka godzin
   * i tylko w bieżącej sesji — dlatego listę pobieramy przy każdym otwarciu instrukcji.
   * @returns {Promise<Array<{key: string, token: string}>>}
   */
  async getSections() {
    return fetchWrapper.get(`${process.env.VUE_APP_API_URL}/manual`);
  }

  /**
   * Adres wideo działu. `<video>` nie wysyła nagłówka Authorization, więc dostęp daje bilet w URL-u.
   * @param {{key: string, token: string}} section
   * @param {boolean} download true = pobranie pliku zamiast odtwarzania.
   */
  videoUrl(section, download = false) {
    const url = `${process.env.VUE_APP_API_URL}/manual/${encodeURIComponent(section.key)}/stream`
      + `?t=${encodeURIComponent(section.token)}`;
    return download ? `${url}&download=1` : url;
  }
}

// Eksport pojedynczej instancji serwisu.
export default new ManualService();
